import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoggerService } from '../../../../shared/sdk';

@Component({
  selector: 'app-dlg-edit-amount',
  templateUrl: './dlg-edit-amount.component.html',
  styleUrls: ['./dlg-edit-amount.component.scss'],
})
export class DlgEditAmountComponent implements OnInit, AfterViewInit {
  value: number;

  @ViewChild('inputElement', { static: true }) inputElement: ElementRef;

  constructor(
    private dialogRef: MatDialogRef<DlgEditAmountComponent, any>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    protected logger: LoggerService,
  ) {
    this.value = data.value;
  }

  ngOnInit() {}

  ngAfterViewInit(): void {
    setTimeout(() => this.inputElement.nativeElement.select());
  }
}
